<template>
  <div
    v-if="chartComponent"
    class="fill-height"
  >
    <component
      :is="chartComponent"
      :stats="stats"
      :variables="variables"
      :event="event"
      :player="player"
      :height="height"
      :aggregation="chart.aggregation"
      :removable="removable"
      :parent-event-id="event.parentEventId"
      @remove="$emit('remove')"
    />
  </div>
</template>

<script>
import VelocityRadialChart from '@/components/charts/implementation/VelocityRadialChart.vue'
import HighSpeedRunningRadialChart from '@/components/charts/implementation/HighSpeedRunningRadialChart.vue'
import DistanceZoneChart from '@/components/charts/implementation/DistanceZoneChart.vue'
import DistancePerMinuteChart from '@/components/charts/implementation/DistancePerMinuteChart.vue'
import VelocityZoneChart from '@/components/charts/implementation/VelocityZoneChart.vue'
import AccelerationZoneChart from '@/components/charts/implementation/AccelerationZoneChart.vue'
import HeartRateZoneIndividualChart from '@/components/charts/implementation/HeartRateZoneIndividualChart.vue'
import RawDataChart from '@/components/charts/implementation/RawDataChart.vue'
import EffortsChart from '@/components/charts/implementation/EffortsChart.vue'
import WellnessOverviewChart from '@/components/charts/implementation/WellnessOverviewChart.vue'
import PlayerWellnessChart from '@/components/charts/implementation/PlayerWellnessChart.vue'

export default {
  name: 'PerformanceGraphIndividual',
  components: {
    VelocityRadialChart,
    HighSpeedRunningRadialChart,
    DistanceZoneChart,
    DistancePerMinuteChart,
    VelocityZoneChart,
    AccelerationZoneChart,
    HeartRateZoneIndividualChart,
    RawDataChart,
    EffortsChart,
    WellnessOverviewChart,
    PlayerWellnessChart
  },
  props: {
    stats: {
      type: Object,
      required: true
    },
    removable: {
      type: Boolean,
      default: false
    },
    chart: {
      type: Object,
      required: true
    },
    variables: {
      type: Array,
      required: true
    },
    event: {
      type: Object,
      default: () => ({})
    },
    player: {
      type: Object,
      default: () => ({})
    },
    height: {
      type: String,
      default: undefined
    }
  },
  computed: {
    chartComponent() {
      const componentMap = {
        VEL_RADIAL: 'VelocityRadialChart',
        HSR_RADIAL: 'HighSpeedRunningRadialChart',
        DIST_ZONE: 'DistanceZoneChart',
        DIST_PER_MIN: 'DistancePerMinuteChart',
        VEL_ZONE: 'VelocityZoneChart',
        ACC_ZONE: 'AccelerationZoneChart',
        HR_ZONE_IND: 'HeartRateZoneIndividualChart',
        RAW_DATA: 'RawDataChart',
        EFFORTS: 'EffortsChart',
        WELL_OVERVIEW: 'WellnessOverviewChart',
        PLAYER_WELLNESS: 'PlayerWellnessChart'
      }

      return componentMap[this.chart.key] || null
    }
  }
}
</script>
